import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const PhoneNumberInput = ({ item, index, signed = false, onChange }) => {
  const handleChange = (value) => {
    if (onChange) {
      onChange(value);
    } else {
      item.answer = value;
    }
  };

  return (
    <div style={{ marginTop: '10px' }}>
      <PhoneInput
        placeholder="Mobile"
        country={'in'}
        value={item.answer || ''}
        onChange={handleChange}
      />
    </div>
  );
};

export default PhoneNumberInput;
